<template>
  <div>
    <div class="overflow-x-auto">
      <b-row
        class="margin-0 background-surface border--solid border--complementary-50 border-radius-8 padding-16"
      >
        <b-col cols="12" class="padding-0 overflow-x-auto">
          <div
            class="min-width-1200 width--max-content table-grid-row font-size-12 color-complementary-300 margin-bottom-8 min-width-1200"
            :style="`gap: 8px; grid-template-columns: repeat(${labels.length}, 1fr); grid-template-columns: ${generateColumnWidthLabels};`"
          >
            <div
              v-for="(label, index) in labels"
              :key="`a-${index}`"
              class="height-64 flex-start padding-x-16 background-light-gray border-radius-top-8 text--center"
              :class="
                !index
                  ? 'background-light-gray'
                  : 'background-double-light-gray'
              "
            >
              <span
                v-b-tooltip.hover
                :title="label"
                class="font-size-16 color-complementary-400 text-ellipsis--line-2 width-percent-100 text--center"
                :class="{ 'text--right': !index }"
              >
                {{ label }}
              </span>
            </div>
          </div>
          <div class="min-width-1200 width--max-content">
            <div
              v-for="(competency, index) in competenciesData"
              :key="`b-${index}`"
              class="table-grid-row margin-bottom-8 last-child-border-radius-left-4 border--solid border--complementary-50 border-radius-8 padding-x-16 padding-y-8 width--max-content"
              :style="`gap: 20px; grid-template-columns: repeat(${labels.length}, 1fr); grid-template-columns: ${generateColumnWidthValues};`"
            >
              <!-- competency -->
              <div
                class="font-size-16 color-complementary-400 border--solid border--complementary-50 border--left border--width-2 padding-left-16 height-percent-100 flex-start"
              >
                {{ competency.name }}
              </div>
              <!-- exercises -->
              <div
                v-for="(exercise, exerciseIndex) in exercisesData"
                :key="`exercise-${exerciseIndex}`"
                class="font-size-14 color-complementary-300 text--center flex-center"
              >
                <div
                  v-if="
                    exercise.id ===
                    getItem(competency.id, exercise.id, ['exerciseId'])
                  "
                  class="cursor--pointer width-percent-100 height-percent-100 flex-center min-height-44"
                  @click="
                    handleOpenCompetencyScorePin(
                      getItem(competency.id, exercise.id)
                    )
                  "
                >
                  <div>
                    <span
                      class="font-size-16 color-complementary-400 width-40 height-40 border-radius-8 flex-center"
                      :class="
                        generateScoreColors(
                          getItem(competency.id, exercise.id, ['score'])
                        )
                      "
                    >
                      {{ getItem(competency.id, exercise.id, ["score"]) }}
                    </span>
                  </div>
                </div>
                <span
                  class="width-percent-100 height-percent-100 flex-center"
                  v-else
                >
                  <img :src="emptyColumnImage" />
                </span>
              </div>
              <!-- conclusion competency -->
              <div
                class="cursor--pointer width-percent-100 height-percent-100 flex-center min-height-44"
              >
                <span class="font-size-16 color-complementary-400">
                  {{ competency.score }}
                </span>
              </div>
            </div>
            <!-- conclusion exercises row -->
            <div
              class="table-grid-row margin-bottom-8 last-child-border-radius-left-4 border--solid border--complementary-50 border-radius-8 padding-x-16 padding-y-8 width--max-content background-complementary-50"
              :style="`gap: 20px; grid-template-columns: repeat(${labels.length}, 1fr); grid-template-columns: ${generateColumnWidthValues};`"
            >
              <div
                class="font-size-16 color-complementary-400 border--solid border--complementary-50 border--left border--width-2 padding-left-16 height-percent-100 flex-start"
              >
                {{ $lang.exercisesConclusion }}
              </div>
              <div
                v-for="(exercise, exerciseIndex) in exercisesData"
                :key="`exercise-${exerciseIndex}`"
                class="font-size-14 color-complementary-300 text--center flex-center"
              >
                <div
                  class="cursor--pointer width-percent-100 height-percent-100 flex-center min-height-44"
                >
                  <span class="font-size-16 color-complementary-400">
                    {{ exercise.score }}
                  </span>
                </div>
              </div>
              <span class="width-percent-100 height-percent-100 flex-center">
                <img :src="emptyColumnImage" />
              </span>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <LeftSidebar
      :visible="isCompetencyScorePin"
      baseClass="competency-score"
      :title="competencyScorePinTitle"
      :width="700"
      :hasHeaderRightIcon="false"
    >
      <template>
        <b-row class="margin-0 padding-16">
          <b-col
            cols="12"
            class="padding-0 font-size-12 color-complementary-300 margin-bottom-8"
          >
            <div>
              {{ $lang.recommendedScore }}:
              <span class="color-complementary-400 font-weight-bold">{{
                recommendedScore
              }}</span>
            </div>
            <div>
              {{ $lang.finalScore }}:
              <span class="color-complementary-400 font-weight-bold">
                {{ pathOr("", ["caption"], finalScore) }}
              </span>
            </div>
            <div>
              {{ $lang.finalConclusion }}:
              <span
                class="color-complementary-400 font-weight-bold"
                v-html="finalDescription"
              />
            </div>
          </b-col>
        </b-row>
      </template>
      <template #footer>
        <Button
          variant="filled-complementary"
          :text="$lang.cancel"
          class="mobile-width-percent-100 tablet-width-percent-100"
          contentClass="justify-content-center"
          @click="handleCloseCompetencyScorePin"
        />
      </template>
    </LeftSidebar>
  </div>
</template>

<script>
import { LeftSidebar } from "@/components/re-design";
import { Button } from "@/components/re-design/forms";
import { toRefs, computed, ref } from "vue";
import { includes, pathOr } from "ramda";
import {
  generateConfig,
  generateLang,
  renderEumOptions,
  setUniqueArrayOfObjects,
} from "@/shared/utils";
export default {
  components: { LeftSidebar, Button },
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const { data } = toRefs(props);
    const generateLabels = (items) => {
      // get all exercises and remove null exercises
      const exercises = items.map(({ exercise }) => exercise).filter(Boolean);

      // remove repeated exercises
      const uniqueExercises = setUniqueArrayOfObjects(exercises, "id");
      // get exercises name
      const exercisesName = uniqueExercises.map(({ name }) => name);

      const competencies = generateLang(["competencies"]);
      const competenciesConclusion = generateLang(["competenciesConclusion"]);
      return [competencies, ...exercisesName, competenciesConclusion];
    };

    const emptyColumnImage = generateConfig([
      "images",
      "shared",
      "redesign",
      "emptyColumn",
    ]);

    const itemsData = computed(() => pathOr([], ["items"], data.value));
    const labels = computed(() => generateLabels(itemsData.value));
    const exercisesData = computed(() => pathOr([], ["exercises"], data.value));
    const competenciesData = computed(() =>
      pathOr([], ["competencies"], data.value)
    );

    const getItem = (competencyId, exerciseId, keys = []) => {
      const item = itemsData.value.find(
        (item) =>
          item.competencyId === competencyId && item.exerciseId === exerciseId
      );
      return keys.length ? pathOr(null, keys, item) : item;
    };

    // generate table columns with
    const generateColumnWidthLabels = computed(() =>
      labels.value
        .map((item, index) => {
          return index ? "209px" : "250px";
        })
        .join(" ")
    );
    const generateColumnWidthValues = computed(() =>
      labels.value
        .map((item, index) => {
          return index ? "191px" : "238px";
        })
        .join(" ")
    );

    const finalScoreOptions = computed(() => {
      // regenerate final score options
      const options = renderEumOptions("competency_score", true);
      return options.map((option) => {
        if (option.id === 0) {
          option.caption = option.caption.replace("0", "w");
        }
        return option;
      });
    });

    // handle competency score modal
    const recommendedScore = ref(null);
    const finalScore = ref(null);
    const finalDescription = ref(null);
    const currentItem = ref(null);
    const isCompetencyScorePin = ref(false);
    const handleOpenCompetencyScorePin = (item) => {
      currentItem.value = item;
      recommendedScore.value = pathOr(null, ["recommendedScore"], item);
      finalDescription.value = pathOr("", ["finalDescription"], item);
      finalScore.value = finalScoreOptions.value.find(
        ({ id }) => id === item.score
      );
      isCompetencyScorePin.value = true;
    };
    const handleCloseCompetencyScorePin = () => {
      isCompetencyScorePin.value = false;
    };

    const competencyScorePinTitle = computed(() => {
      const competencyName = pathOr(
        "",
        ["competency", "name"],
        currentItem.value
      );
      const exerciseName = pathOr("", ["exercise", "name"], currentItem.value);
      return `${generateLang([
        "competencyScore",
      ])} ${competencyName} ${generateLang(["at"])} ${exerciseName}`;
    });

    const generateScoreColors = (score) => {
      const colorsClass = {
        0: "background-error color-surface",
        1: "background-error color-surface",
        2: "background-error-50 color-error",
        3: "background-primary color-surface",
        4: "background-success-50 color-success",
        5: "background-success color-surface",
      };
      return pathOr("", [score], colorsClass);
    };

    // return data to be used in template
    return {
      pathOr,
      emptyColumnImage,
      labels,
      competenciesData,
      exercisesData,
      getItem,
      competencyScorePinTitle,
      isCompetencyScorePin,
      recommendedScore,
      finalScore,
      finalDescription,
      handleOpenCompetencyScorePin,
      handleCloseCompetencyScorePin,
      generateColumnWidthLabels,
      generateColumnWidthValues,
      data,
      generateScoreColors,
    };
  },
};
</script>
<style lang="scss">
.table-grid-row {
  display: grid;
  grid-template-rows: auto;
  align-items: start;
  gap: 8px;
}
.table-body {
  min-width: 1200px;
}
.border-radius-left-4 {
  border-radius: 4px 0 0 4px;
}
.last-child-border-radius-left-4 {
  span:last-child {
    @extend .border-radius-left-4;
  }
}
</style>
